import { useCallback } from 'react';

import './App.scss';
import Messenger from './Components/Messenger/Messenger';
import Navigation from './Components/Navigation/Navigation';
import ErrorPage from './Components/ErrorPage/ErrorPage';
import ChatLandingPage from './Pages/ChatLandingPage/ChatLandingPage';
import AnalyticsDashboardPage from './Pages/AnalyticsDashboardPage/AnalyticsDashboardPage';
import RegularPersonSearchPage from './Pages/RegularPersonSearchPage/RegularPersonSearchPage';
import ContactDetailPage from './Pages/ContactDetailPage/ContactDetailPage';
import NotAdminMessagePage from './Pages/NotAdminMessagePage/NotAdminMessagePage';

import { Route, Routes, Navigate } from 'react-router-dom';

// function App() {
//   return (
//     <div className="App">
//       <Navigation />
//       <Messenger />
//     </div>
//   );
// }

function App() {
  const isDefaultUrl = window.location.pathname === '/';
  const ProtectedRoute = useCallback(({ isDefaultUrl, children }) => {
    if (isDefaultUrl) {
      return <Navigate to="/chat" replace />;
    }

    return children;
  }, []);
  const isDashboardPage =
    window.location.pathname === '/chat' ||
    (window.location.pathname === '/analytics' &&
      localStorage.getItem('analyticsDashboardTabSelection') === 'real_time')
      ? 'disableScroll'
      : 'default';
  return (
    <div className={isDashboardPage}>
      <Navigation />
      <Routes>
        <Route path="/signup" element={<Messenger />} />
        <Route path="/chat" element={<ChatLandingPage />} />
        <Route path="/personsearch" element={<RegularPersonSearchPage />} />
        <Route path="/contact-detail" element={<ContactDetailPage />} />
        <Route path="/analytics" element={<AnalyticsDashboardPage />} />
        <Route path="/notadminpage" element={<NotAdminMessagePage />} />

        {/* <Route path="/" element={<ChatLandingPage />} /> */}
        <Route
          path="/errorpage"
          element={
            <ErrorPage
              errorMessage={
                'Sorry, for privacy reasons, only newsrooms are able to access this full message.'
              }
            />
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute isDefaultUrl={isDefaultUrl}>
              <ChatLandingPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
